import i18n from '@/i18n';
export const getWeekDays = (withWeekends = false) => {
    const days = [
        { text: i18n.tc('Mo.'), value: 'monday' },
        { text: i18n.tc('Tu.'), value: 'tuesday' },
        { text: i18n.tc('We.'), value: 'wednesday' },
        { text: i18n.tc('Th.'), value: 'thursday' },
        { text: i18n.tc('Fr.'), value: 'friday' },
    ];
    if (withWeekends) {
        days.push({ text: i18n.tc('Sa.'), value: 'saturday' }, { text: i18n.tc('Su.'), value: 'sunday' });
    }
    return days;
};
